export { default, type InputProps } from './Input';
